"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FilterChipsContainer = function FilterChipsContainer(_ref) {
  var intl = _ref.intl,
      className = _ref.className,
      children = _ref.children;

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      collapsed = _useState2[0],
      setCollapsed = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex relative h-10', {
      'overflow-hidden': collapsed,
      'overflow-visible': !collapsed
    }, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('w-full bg-white absolute flex transition duration-300 border border-transparent', {
      'shadow-lg rounded overflow-hidden border-gray-200 z-20': !collapsed
    })
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: (0, _classnames["default"])('flex-1 overflow-auto', {
      'h-64': !collapsed
    })
  }, children), /*#__PURE__*/_react["default"].createElement("span", {
    role: "button",
    tabIndex: 0,
    className: (0, _classnames["default"])('p-1 ml-auto self-start cursor-pointer  transition duration-300 transform', {
      'rotate-180': !collapsed
    }),
    title: intl.formatMessage({
      id: collapsed ? 'filters.chips.showMore' : 'filters.chips.showLess'
    }),
    onClick: function onClick() {
      return setCollapsed(function (isCollapsed) {
        return !isCollapsed;
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.ArrowDownward, {
    className: (0, _classnames["default"])('fill-primary')
  }))));
};

FilterChipsContainer.propTypes = {
  intl: _nicbaseTranslation.intlShape.isRequired,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};
FilterChipsContainer.defaultProps = {
  className: '',
  children: null
};

var _default = (0, _nicbaseTranslation.injectIntl)(FilterChipsContainer);

exports["default"] = _default;